import React from 'react';
import PropTypes from 'prop-types';

const DayMonthYearError = (props) => {
  const { meta, meta: { touched, error } } = props;
  return (
    meta && touched && error ? <span className="form-validation-message">{error}</span> : null
  );
};

DayMonthYearError.propTypes = {
  meta: PropTypes.object
};

export default DayMonthYearError;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/DayMonthYear/DayMonthYearError.js
 **/